export const normalizeSearchText = (text) => String(text ?? '')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .toLowerCase()
  .trim();

export const filterOptions = ({ options, filterText, selectedValues = [], pinnedValues = [] }) => {
  const normalizedFilter = normalizeSearchText(filterText);
  const selectedSet = new Set(selectedValues);
  const pinnedSet = new Set(pinnedValues);

  return options.filter((option) => {
    if (pinnedSet.has(option.value)) return true;
    if (selectedSet.has(option.value)) return true;
    if (!normalizedFilter) return true;
    const searchKey = option.searchKey ?? normalizeSearchText(option.label);
    return searchKey.includes(normalizedFilter);
  });
};
